export const downloadOrders = (shellOnly, selectedIds, download) => {
  const options = {
    url: "orders",
    method: "get",
    headers: {
      Accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    },
    params: { shellOnly, search: `id=in=(${selectedIds.join(",")})` },
    responseType: "arraybuffer"
  };
  download(options, {
    onSuccess: response => {
      if (response?.status === 200) {
        const header = response.headers["content-disposition"];
        var filename = header ? header.match(/filename="(.+)"/)[1] : `ORDERS.xlsx`;

        let blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = filename;
        link.click();
      }
    }
  });
};
